import { Link } from "react-router-dom";
import { useState } from "react";

const footerLinks = {
  navigation: {
    title: "快速导航",
    links: [
      { name: "首页", path: "/" },
      { name: "明星爆料", path: "/category/star-gossip" },
      { name: "网红黑料", path: "/category/influencer-gossip" },
    ],
  },
  categories: {
    title: "热门分类",
    links: [
      { name: "综艺爆料", path: "/category/show-gossip" },
      { name: "娱乐圈内幕", path: "/category/industry-insider" },
      { name: "偶像团体", path: "/category/idol-group" },
    ],
  },
  encyclopedia: {
    title: "黑料百科",
    links: [
      { name: "辨别真假八卦", path: "/article/how-to-spot-fake-gossip" },
      { name: "娱乐圈潜规则", path: "/article/entertainment-industry-unspoken-rules" },
      { name: "吃瓜文化演变", path: "/article/history-of-gossip-culture" },
    ],
  },
  about: {
    title: "关于我们",
    links: [
      { name: "品牌介绍", path: "/about" },
      { name: "联系方式", path: "/about" },
      { name: "隐私政策", path: "/about" },
    ],
  },
};

const socialLinks = [
  { icon: "ri-weibo-line", label: "微博", url: "#" },
  { icon: "ri-wechat-line", label: "微信", url: "#" },
  { icon: "ri-tiktok-line", label: "抖音", url: "#" },
  { icon: "ri-bilibili-line", label: "B站", url: "#" },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitStatus, setSubmitStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setSubmitStatus("loading");
    const formData = new FormData();
    formData.append("email", email);

    try {
      const res = await fetch("https://readdy.ai/api/form/d916gdi181e9e92u99r0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email }).toString(),
      });
      if (res.ok) {
        setSubmitStatus("success");
        setEmail("");
      } else {
        setSubmitStatus("error");
      }
    } catch {
      setSubmitStatus("error");
    }
  };

  return (
    <footer className="bg-secondary-950 text-background-50">
      {/* World map decorative background */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
          <div className="absolute inset-0 flex items-center justify-center text-[400px] font-bold text-background-50 select-none">
            🌐
          </div>
        </div>

        <div className="relative px-6 md:px-10 py-14 md:py-18">
          {/* Top section */}
          <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
            {/* Left - Brand + Subscribe */}
            <div className="lg:w-[380px] shrink-0">
              <Link to="/" className="inline-flex items-center gap-2 mb-6">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-line text-lg text-background-50 dark:text-foreground-950"></i>
                </div>
                <span className="font-heading text-2xl font-bold text-background-50 tracking-wide">
                  黑料网<span className="text-primary-400">.</span>
                </span>
              </Link>

              {/* Subscribe form */}
              <form
                data-readdy-form=""
                onSubmit={handleSubscribe}
                className="flex items-center gap-0 mb-6"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入邮箱订阅每日爆料"
                  required
                  className="flex-1 h-11 px-4 text-sm bg-transparent border border-background-50/20 rounded-l-lg text-background-50 placeholder:text-background-50/40 outline-none focus:border-primary-400 transition-colors"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                />
                <button
                  type="submit"
                  disabled={submitStatus === "loading"}
                  className="h-11 px-4 bg-primary-500 hover:bg-primary-600 rounded-r-lg flex items-center justify-center transition-colors duration-200 cursor-pointer disabled:opacity-60 whitespace-nowrap"
                >
                  {submitStatus === "loading" ? (
                    <i className="ri-loader-4-line animate-spin text-background-50"></i>
                  ) : (
                    <i className="ri-mail-send-line text-background-50"></i>
                  )}
                </button>
              </form>
              {submitStatus === "success" && (
                <p className="text-xs text-primary-400 mb-4">订阅成功！每天精彩爆料准时送达~</p>
              )}
              {submitStatus === "error" && (
                <p className="text-xs text-accent-400 mb-4">订阅失败，请稍后再试</p>
              )}

              {/* Slogan */}
              <p className="font-heading text-lg md:text-xl text-background-50/80 leading-relaxed">
                你的专属娱乐八卦雷达
              </p>
              <p className="font-heading text-lg md:text-xl text-background-50/60 leading-relaxed">
                不错过任何一个瓜
              </p>
            </div>

            {/* Right - Link columns */}
            <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-8">
              {Object.values(footerLinks).map((section) => (
                <div key={section.title}>
                  <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">
                    {section.title}
                  </h4>
                  <ul className="space-y-2.5">
                    {section.links.map((link) => (
                      <li key={link.name}>
                        <Link
                          to={link.path}
                          className="text-sm text-background-50/55 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                        >
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-50/10 px-6 md:px-10 py-5">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40 order-2 sm:order-1">
            &copy; 2026 黑料网 HeiLiaoWang. All rights reserved.
          </p>

          <div className="flex items-center gap-3 order-1 sm:order-2">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.url}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center border border-background-50/20 rounded-lg text-background-50/60 hover:text-primary-400 hover:border-primary-400/50 transition-all duration-200 cursor-pointer"
                aria-label={social.label}
              >
                <i className={`${social.icon} text-sm`}></i>
              </a>
            ))}
          </div>

          <Link
            to="/about"
            className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors duration-200 order-3"
          >
            隐私政策
          </Link>
        </div>
      </div>
    </footer>
  );
}